import Vue from "vue";
const http = Vue.prototype.$http;

export async function index(client_id) {
  const response = await Vue.prototype.$http.get(
    `/clients/${client_id}/addresses`
  );

  return response.data;
}

export async function show(client_id, id) {
  const response = await Vue.prototype.$http.get(
    `/clients/${client_id}/addresses/${id}`
  );

  return response.data;
}

export async function update(client_id, id, payload) {
  const response = await Vue.prototype.$http.put(
    `/clients/${client_id}/addresses/${id}`,
    payload
  );

  return response.data;
}

export async function create(client_id, payload) {
  const response = await Vue.prototype.$http.post(
    `/clients/${client_id}/addresses`,
    payload
  );

  return response.data;
}

export async function destroy(client_id, id) {
  const response = await Vue.prototype.$http.delete(
    `/clients/${client_id}/addresses/${id}`
  );

  return response.data;
}
